<template>
  <div class="page-content calendar clearfixing">
    <div class="page-title">
      <span>{{ $lang.messages.calendar.toUpperCase() }}</span>
      <span class="box-name-info" @click="tooltip = true" :class="{ 'blue-box-info': tooltip}"></span>
      <f-p-tooltip
        v-if="tooltip"
        v-click-outside="hideTooltip"
        :hideTooltipInside="hideTooltip"
        :tooltipTitle="$lang.messages.tp_parentingCalendarTitle"
        :tooltipContent="$lang.messages.tp_parentingCalendarText">
      </f-p-tooltip>
    </div>
    <div class="page-header">
      <router-link :to="{ name: 'AddEvent' }" class="link">
        <button class="generic-btn">
          {{ $lang.messages.addEvent }}
          <img class="btn-icon" src='@/assets/images/payments/arrow_right_blue.png' />
        </button>
      </router-link>
      <router-link :to="{ name: 'ScheduleChildVisitation' }" class="link">
        <button class="generic-btn">
          {{ $lang.messages.scheduleChildVisitation }}
          <img class="btn-icon" src='@/assets/images/payments/arrow_right_blue.png' />
        </button>
      </router-link>
      <div class="filter-select-btn">
        <div @click="toggleShowFilters">
          <span v-if="!showFilters">{{ $lang.messages.showFilters }}</span>
          <span v-if="showFilters">{{ $lang.messages.hideFilters }}</span>
          <img class="select-icon" src='@/assets/images/arrow_down.png' :class="{'select-icon-rotate': showFilters}" />
        </div>
      </div>
    </div>

    <div class="page-wrapper">
      <div class="table-all-filters clearfixing" :class="{'show-filters': showFilters}">
        <div class="table-filters">
          <div class="part short-part">
            <p class="label">{{ $lang.messages.eventType }}</p>
            <div class="wrapper">
              <children-checklist
                ref="eventType"
                :name="'eventType'"
                :items="eventTypes"
                :option="selectedEventTypes"
                :placeholder="$lang.messages.selectEventType"
                :validateProp="false"
                @optionChanged="onSelectedEventType"
                :key="rerenderAutocomplete"/>
            </div>
          </div>
          <div class="part short-part">
            <p class="label">{{ $lang.messages.children }}</p>
            <div class="wrapper">
              <children-checklist
                ref="children"
                :items="childrenList"
                :option="selectedChildren"
                :placeholder="$lang.messages.selectChildren"
                :validateProp="false"
                @optionChanged="onSelectedChildren"
                :key="rerenderChecklist" />
            </div>
          </div>
        </div>

        <div class="table-filters selected-filters">
          <button class="clear-btn" @click="clearAllFilters">
            <span>X</span>
            {{ $lang.messages.clearAllFilters }}
          </button>
<!--          <button class="action-btn" @click="applyFilters">-->
<!--            <span>{{ $lang.messages.applyFilters }}</span>-->
<!--          </button>-->
        </div>

      </div>
      <hr class="content-devider" :class="{'hidden': !showFilters}">

      <calendar-basic
        ref="fpCalendar"
        :key="rerenderCalendar"
        :childrenList="childrenList"
        :eventsList="eventsList"
        :childVisitationsList="childVisitationsList"
        :paymentsList="paymentsList"
        :showEvents="showEvents"
        :showVisitations="showVisitations"
        :first-day-of-week="firstDayOfWeek"
        :dateParam="this.$route.params.date"
        @loadData="loadData">
      </calendar-basic>
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import { GET_EVENTS, GET_PAYMENTS, GET_CASES } from "@/store/action.types";
  import Autocomplete from "@/components/common/Autocomplete";
  import ChildrenChecklist from "@/components/common/ChildrenChecklist";
  import CalendarBasic from "./CalendarBasic";
  import { requestDateFormatUTC, requestDateFormat, dateFormat } from '@/mixins/dateFormat';
  import vClickOutside from 'v-click-outside';
  import STATUS_CODES from "@/common/statusCodes";

  export default {
    name: "calendar",
    components: {
      Autocomplete,
      ChildrenChecklist,
      CalendarBasic,
      'f-p-tooltip': () => import('@/components/common/FPTooltip'),
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    mixins: [
      requestDateFormatUTC,
      requestDateFormat,
      dateFormat
    ],
    data() {
      return {
        showFilters: false,
        selectedChildren: [],
        allChildrenGuids: [],
        rerenderChecklist: 0,
        eventTypes: [
          {
            name: 'Event',
            value: 'EVENT',
            clicked: false,
          },
          {
            name: 'Child Visitation',
            value: 'CHILD_VISITATION',
            clicked: false,
          },
          {
            name: 'Special Dates',
            value: 'SPECIAL_DATES',
            clicked: false,
          }
        ],
        selectedEventTypes: [],
        rerenderAutocomplete: 0,
        rerenderCalendar: 0,
        casesList: [],
        filteredCasesList: [],
        eventsList: [],
        filteredEventsList: [],
        childVisitationsList: [],
        filteredChildVisitationsList: [],
        paymentsList: [],
        childrenList: [],
        showEvents: true,
        showVisitations: true,
        isMoreVisitation: false,
        howManyCalBoxes: 0,
        tooltipId: 0,
        firstDayOfWeek: 1,
        tooltip: false,
      };
    },
    computed: {
      children() {
        return this.$store.getters.cases.reduce((children, caseIt) => children.concat(caseIt.children.map(child => child)), []);
      },
    },
    mounted() {
      this.loadCases();
    },
    methods: {
      ...mapActions({
        getCasesAction: GET_CASES,
        getEventsAction: GET_EVENTS,
        getPaymentsAction: GET_PAYMENTS
      }),
      loadCases() {
        this.getCasesAction()
        .then((response) => {
          this.allChildrenGuids = [];
          this.childrenList = [];
          response.data.data.coparents.forEach(coparent => {
            coparent.children.forEach(child => {
              this.childrenList.push(child);
              this.allChildrenGuids.push(child.childGuid)
            })
          });
          // Payments will be implemented later, don't delete this part of code
          // this.loadPayments()
          this.loadCalendar();
        })
        .catch(error => {
          if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
            this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
          }
        })
      },
      // Payments will be implemented later, don't delete this part of code
      loadPayments() {
        let startDate = this.requestDateFormat(this.$refs.fpCalendar.startDate);
        let endDate = this.requestDateFormat(this.$refs.fpCalendar.endDate);
        this.paymentsList = [];

        this.getPaymentsAction({
          "paymentDateFrom": startDate,
          "paymentDateTo": endDate
        })
        .then(response => {
          this.paymentsList = response.data.data.expenseDetailsResponseDtos;
        })
        .catch(error => {
          if(error.response) {
            if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
              this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
            }
          }
        })
      },
      loadCalendar() {
        this.allChildrenGuids = [];
        if (this.selectedChildren.length !== 0) {
          this.selectedChildren.forEach(child => {
            this.allChildrenGuids.push(child.childGuid)
          })
        } else {
          this.children.forEach(child => {
            this.allChildrenGuids.push(child.childGuid)
          })
        }

        let startDate = this.requestDateFormat(this.$refs.fpCalendar.startDate);
        let endDate = this.requestDateFormat(this.$refs.fpCalendar.endDate);

        this.eventsList = [];
        this.childVisitationsList = [];

        if (this.allChildrenGuids.length > 0) {
          this.getEventsAction({
            "childrenGuids": this.allChildrenGuids,
            "startDate": startDate,
            "endDate": endDate
          })
          .then(response => {
            this.eventsList = response.data.data.eventDtos;
            this.childVisitationsList = response.data.data.calendarVisitations;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
                this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
              }
            }
          })
        }
      },
      loadData() {
        this.casesList = [];
        this.filteredCasesList = [];
        this.eventsList = [];
        this.filteredEventsList = [];
        this.eventTypes.forEach( type => type.clicked = false);
        this.childVisitationsList = [];
        this.filteredChildVisitationsList = [];
        this.paymentsList = [];
        this.loadCases()
      },
      onSelectedChildren(results) {
        this.selectedChildren = [];
        results.forEach(element => {
          if (element.clicked) {
            this.selectedChildren.push(element)
          }
        });
        this.applyChildrenFilters();

        // When user selects some of the values inside children filter and deselects all,
        // and the event type filter is empty as well, show the initial data on calendar
        if (!this.selectedChildren.length && !this.selectedEventTypes.length) {
          this.clearAllFilters();
        }
      },
      onSelectedEventType(results) {
        this.selectedEventTypes = [];
        results.forEach(element => {
          if (element.clicked) {
            this.selectedEventTypes.push(element)
          }
        });
        this.applyEventTypeFilters();

        // When user selects some of the values inside event types filter and deselect all,
        // and the children filter is empty as well, show the initial data on calendar
        if (!this.selectedEventTypes.length && !this.selectedChildren.length) {
          this.clearAllFilters();
        }
      },
      toggleShowFilters() {
         this.showFilters = !this.showFilters
      },
      applyEventTypeFilters() {
        let eventsFound = false;
        let visitationsFound = false;
        let specialDatesFound = false;

        this.selectedEventTypes.forEach(type => {
          if (type.clicked && type.value === 'EVENT') {
            eventsFound = true
          } else if (type.clicked && type.value === 'CHILD_VISITATION') {
            visitationsFound = true
          } else if (type.clicked && type.value === 'SPECIAL_DATES') {
            specialDatesFound = true
          }
        });
        if(this.selectedEventTypes.length===0){
          eventsFound = true;
          visitationsFound = true;
        }

        this.showEvents = eventsFound;
        this.showVisitations = visitationsFound;
      },
      applyChildrenFilters() {
        this.loadCases();
      },
      clearAllFilters() {
        this.selectedEventTypes = [];
        this.eventTypes.forEach( type => type.clicked = false);
        this.selectedChildren = [];
        this.showEvents = true;
        this.showVisitations = true;
        this.rerenderChecklist+=1;
        this.rerenderAutocomplete+=1;
        this.filteredEventsList = [];
        this.filteredChildVisitationsList = [];
        this.loadCases()
      },
      hideTooltip(e) {
        e.stopPropagation();
        this.tooltip = false;
      },
    },
  };
</script>
